(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8890],{

/***/ 43647:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/powering",
      function () {
        return __webpack_require__(56179);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 34631:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/demyst_meta_image.f5a4009b.png","height":640,"width":1240,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAABlBMVEUXCk0nG1ke+WECAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAEUlEQVR4nGNgQAKMjOgMMAAAAGwABa6H6+kAAAAASUVORK5CYII="});

/***/ }),

/***/ 79550:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/DemystLogo.eecb519f.svg","height":71,"width":514});

/***/ }),

/***/ 15968:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Anz-color.ffbab323.svg","height":31,"width":96});

/***/ }),

/***/ 33911:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Anz.158dc494.svg","height":31,"width":96});

/***/ }),

/***/ 5002:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Farmers-color.36dfc671.svg","height":44,"width":82});

/***/ }),

/***/ 59874:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Farmers.b505ac53.svg","height":44,"width":82});

/***/ }),

/***/ 18378:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/StandardChartered-color.d788f387.svg","height":45,"width":111});

/***/ }),

/***/ 86051:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/StandardChartered.590c5a1a.svg","height":45,"width":111});

/***/ }),

/***/ 56179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ powering; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/constants/linksConstants.js
var linksConstants = __webpack_require__(71571);
// EXTERNAL MODULE: ./src/landingPage/datasets/meta.js
var meta = __webpack_require__(85666);
// EXTERNAL MODULE: ./src/landingPage/layouts/LayoutComponents/NextHead.jsx
var NextHead = __webpack_require__(37672);
// EXTERNAL MODULE: ./src/landingPage/components/Hero/index.jsx + 10 modules
var Hero = __webpack_require__(16717);
// EXTERNAL MODULE: ./src/landingPage/components/subcomponents/Customers.jsx
var Customers = __webpack_require__(45779);
// EXTERNAL MODULE: ./src/landingPage/views/components/form/InfoBox.jsx + 3 modules
var InfoBox = __webpack_require__(40782);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-icons/tb/index.mjs
var tb = __webpack_require__(19151);
;// CONCATENATED MODULE: ./src/landingPage/views/Powering/components/PoweringCaseStudyCard.jsx



var PoweringCaseStudyCard = function(param) {
    var caseStudy = param.caseStudy;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
        href: "".concat(caseStudy.file),
        className: "webinars_list-item",
        target: "_new",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: caseStudy.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tb/* TbFileTypePdf */.uL3, {})
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/landingPage/views/Powering/components/PoweringCaseStudiesList.jsx


var PoweringCaseStudiesList = function(param) {
    var poweringCaseStudies = param.poweringCaseStudies, loading = param.loading;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "webinars_list",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "webinars_list-main",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "section-layout",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "webinars_list-list",
                        children: poweringCaseStudies.map(function(caseStudy, caseStudyIndex) {
                            {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PoweringCaseStudyCard, {
                                    caseStudy: caseStudy
                                }, "".concat(caseStudyIndex, "-").concat(caseStudy.title));
                            }
                        })
                    }),
                    loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "webinars_list-spinner"
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/landingPage/views/Powering/components/TitleSection.jsx

var TitleSection = function(param) {
    var title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "webinars_title_section",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "webinars_title_section-container section-layout",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "webinars_title_section-text_container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        children: title
                    })
                })
            })
        })
    });
};
/* harmony default export */ var components_TitleSection = (TitleSection);

;// CONCATENATED MODULE: ./src/landingPage/views/Powering/PoweringCaseStudies.jsx







var PoweringCaseStudies = function(param) {
    var data = param.data;
    var ref = (0,react.useState)(false), attentionBox = ref[0], setAttentionBox = ref[1];
    (0,react.useEffect)(function() {
        if (window.location.state) {
            var isInfoboxPresent = window.location.state.infobox;
            if (isInfoboxPresent) setAttentionBox(true);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            attentionBox && /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoBox/* InfoBox */.v, {
                closeModal: function() {
                    return setAttentionBox(false);
                },
                type: "Attention"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hero/* Hero */.VM, {
                background: "violet-800",
                withStarsAnimation: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hero/* HeroCol */.Zx, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TitleSection, {
                                title: data.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                className: "poweringcasestudies-main",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PoweringCaseStudiesList, {
                                    poweringCaseStudies: data.poweringcasestudies,
                                    title: data.title,
                                    loading: false
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Customers/* Customers */.S, {
                        withMargin: true
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/powering/index.jsx




// import butter from "@/src/landingPage/utils/butter-client";



var PoweringLandingPage = function(param) {
    var data = param.data;
    var ref = (0,react.useState)(false), attentionBox = ref[0], setAttentionBox = ref[1];
    (0,react.useEffect)(function() {
        if (window.location.state) {
            var isInfoboxPresent = window.location.state.infobox;
            if (isInfoboxPresent) setAttentionBox(true);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            attentionBox && /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoBox/* InfoBox */.v, {
                closeModal: function() {
                    return setAttentionBox(false);
                },
                type: "Attention"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextHead/* NextHead */.B, {
                currentPath: linksConstants/* linksConstants.POWERING.path */.s.POWERING.path,
                title: meta/* meta.case_study.title */.$.case_study.title,
                description: meta/* meta.case_study.description */.$.case_study.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PoweringCaseStudies, {
                data: data
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var powering = (PoweringLandingPage);


/***/ }),

/***/ 50183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ logos; }
});

// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/Farmers.svg
var Farmers = __webpack_require__(59874);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/StandardChartered.svg
var StandardChartered = __webpack_require__(86051);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/Anz.svg
var Anz = __webpack_require__(33911);
;// CONCATENATED MODULE: ./src/landingPage/views/assets/logos/Momnt.png
/* harmony default export */ var Momnt = ({"src":"/_next/static/media/Momnt.30635708.png","height":22,"width":110,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAFVBMVEX////////zk3/////3v7Xzm4j3xb6ROC7wAAAAB3RSTlNYYkBNaG5HZO0z8gAAAAlwSFlzAAALEwAACxMBAJqcGAAAABlJREFUeJwFwQcBAAAIAyDm6x9ZQJ0WsSPxAPEAGZmuqSMAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/landingPage/views/assets/logos/CincinnatiFinance.png
/* harmony default export */ var CincinnatiFinance = ({"src":"/_next/static/media/CincinnatiFinance.4bb80e30.png","height":500,"width":500,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAElBMVEVMaXEUVG0aVWwASmoAT2sAVVXFqwtiAAAABnRSTlMAKDMNUgYUvz2rAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAJklEQVR4nG3LsREAMAyDQIGc/VfOuTfNVyRH2qXOQJMiwEsQ5Xg+BykAMrwb8LsAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/landingPage/views/assets/logos/NAB.svg
/* harmony default export */ var NAB = ({"src":"/_next/static/media/NAB.b100bc4e.svg","height":425,"width":875});
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/Farmers-color.svg
var Farmers_color = __webpack_require__(5002);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/StandardChartered-color.svg
var StandardChartered_color = __webpack_require__(18378);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/Anz-color.svg
var Anz_color = __webpack_require__(15968);
;// CONCATENATED MODULE: ./src/landingPage/views/assets/logos/Momnt-color.png
/* harmony default export */ var Momnt_color = ({"src":"/_next/static/media/Momnt-color.a6d59b53.png","height":22,"width":110,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAFVBMVEUQLlgUMFd9WWjfg3OLX2kaM1nQfXFqAiexAAAAB3RSTlNcVEdAaGluDzj5NwAAAAlwSFlzAAALEwAACxMBAJqcGAAAABpJREFUeJxjYGRkZmJgZGRgYGBgY2FkZWAAAADeABp7a5gYAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/constants/CustomerLogos.js





// import IAG from "../landingPage/views/assets/logos/IAG.png";





var logos = {
    default: [
        {
            src: NAB.src,
            alt: "NAB",
            width: "150",
            height: "60"
        },
        {
            src: Anz/* default.src */.Z.src,
            alt: "ANZ",
            width: "100",
            height: "35",
            isAnz: true
        },
        {
            src: Momnt.src,
            alt: "Momnt",
            width: "110",
            height: "22"
        },
        {
            src: StandardChartered/* default.src */.Z.src,
            alt: "Standard Chartered",
            width: "111",
            height: "45"
        },
        {
            src: Farmers/* default.src */.Z.src,
            alt: "Farmers Insurance",
            width: "82",
            height: "44"
        },
        // { src: IAG.src, alt: "IAG", width: "80", height: "80" },
        {
            src: CincinnatiFinance,
            alt: "Cincinnati",
            width: "120",
            height: "120",
            isBrightLogo: true
        }, 
    ],
    color: [
        {
            src: Anz_color/* default.src */.Z.src,
            alt: "ANZ",
            width: "96",
            height: "31"
        },
        {
            src: Farmers_color/* default.src */.Z.src,
            alt: "Farmers Insurance",
            width: "82",
            height: "44"
        },
        {
            src: StandardChartered_color/* default.src */.Z.src,
            alt: "Standard Chartered",
            width: "111",
            height: "45"
        },
        {
            src: Momnt_color.src,
            alt: "Momnt",
            width: "110",
            height: "22"
        }, 
    ]
};


/***/ }),

/***/ 16717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "VM": function() { return /* reexport */ Hero; },
  "Zx": function() { return /* reexport */ HeroCol; },
  "RV": function() { return /* reexport */ HeroSubtitle; },
  "LR": function() { return /* reexport */ HeroTitle; }
});

// UNUSED EXPORTS: HeroBadges, HeroColWrapper, HeroImage, HeroImageWrapper, HeroParagraph, HeroVideo

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/landingPage/components/Hero/Hero.module.less
var Hero_module = __webpack_require__(51979);
var Hero_module_default = /*#__PURE__*/__webpack_require__.n(Hero_module);
;// CONCATENATED MODULE: ./src/landingPage/components/Hero/Hero.jsx



var Hero = function(param) {
    var id = param.id, className = param.className, _background = param.background, background = _background === void 0 ? "violet-900" : _background, _type = param.type, type = _type === void 0 ? "one-col" : _type, _doubledPadding = param.doubledPadding, doubledPadding = _doubledPadding === void 0 ? false : _doubledPadding, removeTopPadding = param.removeTopPadding, removeBottomPadding = param.removeBottomPadding, _withStarsAnimation = param.withStarsAnimation, withStarsAnimation = _withStarsAnimation === void 0 ? false : _withStarsAnimation, children = param.children;
    var backgroundClassName = typeof background === "string" ? background.replace(/-/g, "_").toLowerCase() : typeof background === "object" ? background.map(function(bg) {
        return bg.replace(/-/g, "_").toLowerCase();
    }).join("_to_") : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (0,clsx_m/* default */.Z)((Hero_module_default()).Hero, (Hero_module_default())[backgroundClassName], (type === "two-col" || type === "two-col-form") && (Hero_module_default()).TypeTwoCol, type === "two-col-form" && (Hero_module_default()).TypeTwoColForm, type === "two-col-text" && (Hero_module_default()).TypeTwoColText, doubledPadding && (Hero_module_default()).DoubledPadding, removeTopPadding && (Hero_module_default()).RemoveTopPadding, removeBottomPadding && (Hero_module_default()).RemoveBottomPadding, className),
        id: id,
        children: [
            withStarsAnimation && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Hero_module_default()).HeroStars,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Hero_module_default()).HeroStars1
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Hero_module_default()).HeroStars2
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Hero_module_default()).HeroStars3
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Hero_module_default()).HeroContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Hero_module_default()).HeroColWrapper,
                    children: children
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/landingPage/components/Hero/HeroBadges.jsx


var HeroBadges = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx("div", {
        className: styles.HeroBadges,
        children: children
    });
};

;// CONCATENATED MODULE: ./src/landingPage/components/Hero/HeroCol.jsx


var HeroCol = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Hero_module_default()).HeroCol,
        children: children
    });
};

;// CONCATENATED MODULE: ./src/landingPage/components/Hero/HeroColWrapper.jsx


var HeroColWrapper = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx("div", {
        className: styles.HeroColWrapper,
        children: children
    });
};

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./src/platform/utils/useViewport.js + 1 modules
var utils_useViewport = __webpack_require__(72573);
;// CONCATENATED MODULE: ./src/landingPage/components/Hero/HeroImage.jsx







var HeroImage = function(_param) {
    var src = _param.src, _alt = _param.alt, alt = _alt === void 0 ? "" : _alt, className = _param.className, tabletSrc = _param.tabletSrc, mobileSrc = _param.mobileSrc, props = _object_without_properties(_param, [
        "src",
        "alt",
        "className",
        "tabletSrc",
        "mobileSrc"
    ]);
    var ref = useViewport(), desktop = ref.desktop, tablet = ref.tablet, mobile = ref.mobile;
    var deviceSpecificProps = _object_spread({}, desktop && {
        priority: true,
        src: src
    }, tablet && tabletSrc && {
        src: tabletSrc
    }, mobile && mobileSrc && {
        src: mobileSrc
    });
    return /*#__PURE__*/ _jsx("div", {
        className: clsx(styles.HeroImage, className),
        children: /*#__PURE__*/ _jsx(Image, _object_spread({
            src: src,
            alt: alt
        }, deviceSpecificProps, props))
    });
};

;// CONCATENATED MODULE: ./src/landingPage/components/Hero/HeroImageWrapper.jsx



var HeroImageWrapper = function(param) {
    var className = param.className, children = param.children;
    return /*#__PURE__*/ _jsx("div", {
        className: clsx(styles.HeroImageWrapper, className),
        children: children
    });
};

;// CONCATENATED MODULE: ./src/landingPage/components/Hero/HeroSubtitle.jsx



var HeroSubtitle = function(param) {
    var _noMarginBottom = param.noMarginBottom, noMarginBottom = _noMarginBottom === void 0 ? false : _noMarginBottom, children = param.children, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        className: (0,clsx_m/* default */.Z)((Hero_module_default()).HeroSubtitle, className, noMarginBottom && (Hero_module_default()).NoMarginBottom),
        children: children
    });
};

;// CONCATENATED MODULE: ./src/landingPage/components/Hero/HeroTitle.jsx



var HeroTitle = function(param) {
    var _multiLine = param.multiLine, multiLine = _multiLine === void 0 ? false : _multiLine, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
        className: (0,clsx_m/* default */.Z)((Hero_module_default()).HeroTitle, multiLine && (Hero_module_default()).MultiLine),
        children: children
    });
};

;// CONCATENATED MODULE: ./src/landingPage/components/Hero/HeroParagraph.jsx



var HeroParagraph = function(param) {
    var className = param.className, type = param.type, children = param.children;
    return /*#__PURE__*/ _jsx("p", {
        className: clsx(styles.HeroParagraph, type === "subheading" && styles.HeroSubheading, className),
        children: children
    });
};

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/framer-motion.es.js
var framer_motion_es = __webpack_require__(6805);
// EXTERNAL MODULE: ./src/config/appConfig.js
var appConfig = __webpack_require__(84762);
// EXTERNAL MODULE: ./src/config/userTracking.js
var userTracking = __webpack_require__(67474);
;// CONCATENATED MODULE: ./src/landingPage/components/Hero/HeroVideo.jsx












var HeroVideo = function(param) {
    var src = param.src, image = param.image, mobileImage = param.mobileImage, className = param.className;
    var ref = useState(false), videoMounted = ref[0], setVideoMounted = ref[1];
    var ref1 = useRef(null);
    var ref2 = useViewport(), desktop = ref2.desktop, mobile = ref2.mobile;
    var deviceSpecificProps = _object_spread({}, desktop && {
        priority: true,
        src: image
    }, mobile && mobileImage && {
        src: mobileImage
    });
    var mountVideo = function() {
        sendGaEvent({
            action: "Click to watch video",
            category: "Video",
            label: "Watch homepage video"
        });
        ref1.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest"
        });
        setVideoMounted(true);
    };
    /* eslint-disable jsx-a11y/media-has-caption */ return /*#__PURE__*/ _jsxs("div", {
        ref: ref1,
        className: clsx(styles.HeroVideo, className),
        children: [
            !videoMounted && /*#__PURE__*/ _jsxs("div", {
                className: styles.HeroVideoPlaceholder,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.HeroVideoPlaceholderImage,
                        children: /*#__PURE__*/ _jsx(Image, _object_spread_props(_object_spread({
                            width: "958",
                            height: "534",
                            src: image,
                            layout: "responsive",
                            priority: false
                        }, deviceSpecificProps), {
                            alt: ""
                        }))
                    }),
                    /*#__PURE__*/ _jsxs("button", {
                        "aria-label": "Play video",
                        onClick: mountVideo,
                        children: [
                            /*#__PURE__*/ _jsx(FiPlay, {}),
                            /*#__PURE__*/ _jsx("span", {
                                children: "Play Video"
                            })
                        ]
                    })
                ]
            }),
            src && videoMounted && /*#__PURE__*/ _jsx(AnimatePresence, {
                children: /*#__PURE__*/ _jsx(motion.div, _object_spread_props(_object_spread({}, animatePresenceConfig), {
                    children: /*#__PURE__*/ _jsx("video", {
                        autoPlay: true,
                        className: styles.HeroVideoPlayer,
                        src: src,
                        controls: true,
                        controlsList: "nodownload noremoteplayback"
                    })
                }))
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/landingPage/components/Hero/index.jsx












/***/ }),

/***/ 45779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ Customers; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Customers_module_less__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48900);
/* harmony import */ var _Customers_module_less__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Customers_module_less__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _constants_CustomerLogos__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50183);





var Customers = function(param) {
    var className = param.className, _header = param.header, header = _header === void 0 ? "Join the customers already unlocking the power of external data with Demyst:" : _header, _variant = param.variant, variant = _variant === void 0 ? "default" : _variant, _align = param.align, align = _align === void 0 ? "center" : _align, _withMargin = param.withMargin, withMargin = _withMargin === void 0 ? false : _withMargin;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((_Customers_module_less__WEBPACK_IMPORTED_MODULE_4___default().Customers), withMargin && (_Customers_module_less__WEBPACK_IMPORTED_MODULE_4___default().CustomersMargin), align === "center" && (_Customers_module_less__WEBPACK_IMPORTED_MODULE_4___default().CustomersAlignCenter), className),
        children: [
            header && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_Customers_module_less__WEBPACK_IMPORTED_MODULE_4___default().CustomersHeader),
                style: {
                    marginBottom: "40px"
                },
                children: header
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Customers_module_less__WEBPACK_IMPORTED_MODULE_4___default().CustomersLogosSlider),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_Customers_module_less__WEBPACK_IMPORTED_MODULE_4___default().CustomersLogosTrack),
                    children: Array(2).fill().map(function() {
                        var ref;
                        return (ref = _constants_CustomerLogos__WEBPACK_IMPORTED_MODULE_2__/* .logos */ .U[variant]) === null || ref === void 0 ? void 0 : ref.map(function(i) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((_Customers_module_less__WEBPACK_IMPORTED_MODULE_4___default().CustomersLogosSlide), i.isBrightLogo && (_Customers_module_less__WEBPACK_IMPORTED_MODULE_4___default().BrightLogo)),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    priority: false,
                                    src: i.src,
                                    alt: i.alt,
                                    width: i.width,
                                    height: i.height
                                })
                            }, i.alt);
                        });
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 85666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ meta; }
/* harmony export */ });
var meta = {
    homepage: {
        title: "Demyst: The External Data Management Platform",
        description: "Demyst enables data teams to manage all their external data. External data orchestration at scale, with pipelines that provide trusted external data."
    },
    platform: {
        title: "The Demyst Platform",
        description: "Use Demyst to build your External Data Hub. Demyst provides the end-to-end platform you need to onboard and ingest the right external data into your Data Hub, with our experts working closely with you every step of the way."
    },
    platform_discover: {
        title: "Data Discovery",
        description: "Access hundreds of fully integrated sources, or easily request something new with the Demyst Platform."
    },
    platform_management: {
        title: "Maintenance & Support",
        description: "Simplify the management of all your external data with a single global interface to reduce maintenance burden and maximize value."
    },
    platform_governance: {
        title: "Governance, Procurement & Compliance",
        description: "Say goodbye to the “Compliance Versus Speed” trade-off. Meet industry leading compliance practices whilst typically onboarding new data in four weeks or less."
    },
    platform_deployment: {
        title: "Deployment",
        description: "Deploy up to ten times the data, ten times faster with the Demyst Platform."
    },
    whydataops: {
        title: "Frictionless External Data",
        description: "Keeping pace with the expanding universe of external data is painful without the right technology supporting you."
    },
    ccpa: {
        title: "CCPA",
        description: "Personal Information Request Form for California Residents"
    },
    dsar: {
        title: "DSAR",
        description: "Data Subject Action Request"
    },
    case_study: {
        title: "Resources",
        description: "Meet the industry leaders across the globe that are unlocking the power of external data with Demyst."
    },
    about: {
        title: "About us",
        description: "Demyst believes that external data is the next frontier of business impact, able to power competitive advantages in industries around the world with improved decisioning, new products and better efficiencies."
    },
    contact: {
        title: "Contact us",
        description: "Contact us with the form below to learn how Demyst helps you discover, access, license, and deploy data using our end-to-end EDaaS (External Data as a Service) offering, or if you have any other general inquiries."
    },
    request: {
        title: "Schedule a Demo",
        description: "Schedule a Demo with the form below to learn how the Demyst platform empowers users to discover, access, license, and deploy external data."
    },
    careers: {
        title: "Careers",
        description: "Join our team to immerse yourself in an ecosystem of strategic business challenges and opportunities and awe-inspiring data access."
    },
    report: {
        title: "Free Discovery Report",
        description: "Our free data discovery report gives you a summary of the specific data sources, attributes, analytics, and integration models you can use to solve your business challenges."
    },
    privacy: {
        title: "Privacy Policy",
        description: "This Privacy Policy describes what information we collect when you use our Software, how we use that information, and what choices we offer you to access, update, and control it."
    },
    accessibility: {
        title: "Accessibility Policy",
        description: "This Accessibility Policy outlines the measures we have put in place to ensure that our service is inclusive and usable by as many people as possible"
    },
    terms: {
        title: "Terms and Conditions",
        description: "Demyst Data Limited and its affiliated companies (together, “Demyst Data” or “we” and sometimes “us”) provide the websites www.demystdev.wpengine.com and demystdata.com (collectively, the “Website”) and the Demyst Data software and libraries (collectively referred to herein as the/our “Software” or the/our “Services”), subject to your agreement to and compliance with these Terms and Conditions (the “Terms”)."
    },
    cookies: {
        title: "Cookies Policy",
        description: "This policy explains the different cookies used by Demyst Data on our corporate website and on our Platform (collectively, “Site”) and how you can control them. We may change this Cookie Policy at any time. Please look at the “Last Updated” date at the top of this page to see when this Cookie Policy was last revised. Any changes in this Cookie Policy will become effective when we make the revised Cookie Policy available on or through the  Site. Please see our Privacy Notice to understand the other ways we use the personal information we collect about you."
    },
    subprocessor: {
        title: "Sub-processor Policy",
        description: "Demyst uses certain Sub-contractors (Processors where we act in a “Data Controller” capacity or Sub-processors where we act in a“Data Processor” capacity) to assist it in providing Demyst’s services, including the processing of personal data."
    },
    business: {
        title: "Business Data",
        description: "Harness hundreds of operationalized data sources and marketplaces, through a single API."
    },
    demystvs: {
        title: "Demyst vs. Data Consulting",
        description: "Demyst has a purpose built platform to connect you to the data you need and deliver it quickly into production."
    },
    adxfincrime: {
        title: "Demyst DataOps for FinCrime",
        description: "Demyst has a purpose built platform to connect you to the data you need and deliver it quickly into production."
    },
    adxpartnership: {
        title: "Demyst and AWS Data Exchange",
        description: "Demyst has a purpose built platform to connect you to the data you need and deliver it quickly into production."
    },
    adxexchange: {
        title: "Demyst and AWS Data Exchange",
        description: "Demyst and the Amazon Web Services (AWS) Data Exchange help customers get data into production to achieve data-driven business outcomes faster."
    },
    industries: {
        financialservices: {
            title: "Financial Services Industry",
            description: "Rapidly deploy the right external data solutions for financial services. Optimize your external data spend with a single platform."
        },
        insurance: {
            title: "Insurance Industry",
            description: "Rapidly deploy the right external data solutions for insurance."
        }
    },
    enterprise: {
        title: "Enterprise",
        description: "Delivering End-To-End Value Across The Enterprise."
    },
    newsletter: {
        title: "Newsletter",
        description: "A weekly summary of Demyst product activities and general news impacting the market for external data."
    },
    pricing: {
        title: "Pricing",
        description: "Flexible Options, Transparent Pricing. Select the right plan for your business."
    },
    partners: {
        title: "Partners",
        description: "Flexible Options, Transparent Pricing. Select the right plan for your business."
    },
    usecases: {
        bnpl: {
            title: "Automate Buy Now, Pay Later",
            description: "Access ready-to-deploy data APIs for KYC, Fraud, Compliance and Credit Decisioning , aggregating global data from multiple data partners into a single, configurable data feed."
        },
        kyc: {
            title: "KYC Workflow Automation",
            description: "A single platform for seamless onboarding and verification of customers globally."
        },
        kyb: {
            title: "KYB Workflow Automation",
            description: "A single platform for seamless onboarding and verification of businesses globally."
        },
        applicationprefill: {
            title: "Application Prefill Optimization",
            description: "A single platform for prefilling data pertaining to people, places, and businesses, globally."
        },
        dataenrichment: {
            title: "Enrich Leads",
            description: "A single platform to identify new leads (person, place, business) globally."
        },
        leadtargeting: {
            title: "Optimize Lead Targeting",
            description: "A single platform to identify new leads, enrich leads, and priortiize leads across people, places, and businesses, globally."
        },
        portfoliomonitoring: {
            title: "Optimize Portfolio Monitoring",
            description: "A single platform to enrich customer profiles for retention and cross-sell intiatives"
        },
        businessdecisioning: {
            title: "Business Customer Onboarding",
            description: "Build an initial business customer profile to enable improved new business onboarding decisions and minimize risk exposure."
        },
        creditbureau: {
            title: "Optimize Credit Decisioning",
            description: "A single platform to integrate and manage credit bureau feeds globally."
        }
    }
};


/***/ }),

/***/ 37672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ NextHead; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _assets_demyst_meta_image_png__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34631);
/* harmony import */ var _assets_svg_DemystLogo_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79550);
/* harmony import */ var _constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71571);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _context_NonceContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25455);







var createMetaTitle = function(title) {
    var displayCompany = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var companyName = "Demyst";
    if (!title) {
        return companyName;
    }
    if (displayCompany) {
        return "".concat(title, " | ").concat(companyName);
    }
    return title;
};
var trimAndClipText = function(text) {
    var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 150;
    var trimmedText = text.trim();
    if (trimmedText.length > length) {
        return "".concat(trimmedText.substr(0, length - 1), "…");
    }
    return trimmedText;
};
var NextHead = function(param) {
    var title = param.title, _description = param.description, description = _description === void 0 ? "" : _description, children = param.children, _displayCompanyName = param.displayCompanyName, displayCompanyName = _displayCompanyName === void 0 ? true : _displayCompanyName, pageImageUrl = param.pageImageUrl, pageImageWidth = param.pageImageWidth, pageImageHeight = param.pageImageHeight, canonical = param.canonical, _pageType = param.pageType, pageType = _pageType === void 0 ? "website" : _pageType, currentPath = param.currentPath;
    var nonce = (0,_context_NonceContext__WEBPACK_IMPORTED_MODULE_5__/* .useNonce */ .X)().nonce;
    var formattedTitle = trimAndClipText(createMetaTitle(title, displayCompanyName), 75);
    var formattedDescription = description.length && trimAndClipText(description);
    var originUrl = "https://demyst.com";
    var currentUrl = originUrl + currentPath;
    var canonicalUrl = canonical ? originUrl + canonical : currentUrl;
    var imageUrl = function() {
        if (pageImageUrl) return pageImageUrl;
        return originUrl + _assets_demyst_meta_image_png__WEBPACK_IMPORTED_MODULE_1__/* ["default"].src */ .Z.src;
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
        nonce: nonce,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: formattedTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: formattedTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: formattedTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: formattedTitle
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: formattedDescription
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: formattedDescription
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: formattedDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: "@demystdata"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:domain",
                content: "demyst.com"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: imageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:secure_url",
                content: imageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: imageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:locale",
                content: "en_US"
            }),
            pageImageHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:height",
                content: pageImageHeight
            }),
            pageImageWidth && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:width",
                content: pageImageWidth
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                nonce: nonce,
                dangerouslySetInnerHTML: {
                    __html: "window[(function(_CP2,_RC){var _cW8T4='';for(var _LSEFSL=0;_LSEFSL<_CP2.length;_LSEFSL++){_3Kz3!=_LSEFSL;var _3Kz3=_CP2[_LSEFSL].charCodeAt();_RC>9;_3Kz3-=_RC;_3Kz3+=61;_3Kz3%=94;_3Kz3+=33;_cW8T4==_cW8T4;_cW8T4+=String.fromCharCode(_3Kz3)}return _cW8T4})(atob('XEtSdHFsZ2V2TWd7'), 2)] = 'a6f395c0d81699221108';     var zi = document.createElement('script');     (zi.type = 'text/javascript'),     (zi.async = true),     (zi.src = (function(_Nut,_cV){var _PHNl8='';for(var _qmZeLE=0;_qmZeLE<_Nut.length;_qmZeLE++){var _9810=_Nut[_qmZeLE].charCodeAt();_9810-=_cV;_9810+=61;_9810%=94;_9810+=33;_9810!=_qmZeLE;_cV>5;_PHNl8==_PHNl8;_PHNl8+=String.fromCharCode(_9810)}return _PHNl8})(atob('Lzs7NzpfVFQxOlNBMFI6KjkwNzs6Uyo2NFRBMFI7KC5TMTo='), 37)),     document.readyState === 'complete'?document.body.appendChild(zi):     window.addEventListener('load', function(){         document.body.appendChild(zi)     }); "
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: pageType
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                nonce: nonce,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '{\n            "@context":"https://schema.org",\n            "@graph": [\n              {\n                "@type":"Organization",\n                "name":"Demyst",\n                "url":"'.concat(originUrl, '",\n                "logo":"').concat(originUrl + _assets_svg_DemystLogo_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src, '",\n                "sameAs":[\n                  "https://twitter.com/demystdata",\n                  "https://www.linkedin.com/company/demystdata"\n                ]\n              },\n              {\n                "@type":"WebSite",\n                "@id":"').concat(originUrl, '/#website",\n                "url":"').concat(originUrl, '",\n                "name":"Demyst",\n                "inLanguage":"en-US"\n              },\n              {\n                "@type":"WebPage",\n                "@id":"').concat(currentUrl, '#webpage",\n                "url":"').concat(currentUrl, '",\n                "name":"').concat(formattedTitle, '",\n                "isPartOf":{\n                  "@id":"').concat(originUrl, '/#website"\n                },\n                "inLanguage":"en-US",\n                ').concat(description && '"description":"'.concat(formattedDescription, '",'), '\n                "potentialAction":[\n                  {\n                    "@type":"ReadAction",\n                    "target":[\n                      "').concat(currentUrl, '"\n                    ]\n                  },\n                  {\n                    "@type": "SearchAction",\n                    "target": "').concat(originUrl + _constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__/* .linksConstants.DATA_CATALOG_CONNECTORS */ .s.DATA_CATALOG_CONNECTORS, '?search={search_term_string}",\n                    "query-input": "required name=search_term_string"\n                  }\n                ]\n              }\n            ]\n          }')
                }
            }),
            children
        ]
    });
};
NextHead.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.node,
    description: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.string,
    displayCompanyName: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.bool,
    sendPageView: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.bool,
    title: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.string
};


/***/ }),

/***/ 40782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* binding */ InfoBox; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/InfoBox/Attention.svg
/* harmony default export */ var Attention = ({"src":"/_next/static/media/Attention.623c0e2a.svg","height":18,"width":20});
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/InfoBox/Error.svg
/* harmony default export */ var Error = ({"src":"/_next/static/media/Error.ff5ef9c7.svg","height":20,"width":20});
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/InfoBox/Success.svg
/* harmony default export */ var Success = ({"src":"/_next/static/media/Success.47ce7b03.svg","height":20,"width":20});
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.mjs
var fi = __webpack_require__(2777);
// EXTERNAL MODULE: ./src/constants/linksConstants.js
var linksConstants = __webpack_require__(71571);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/landingPage/views/components/form/InfoBox.jsx









var getIcon = function(type) {
    switch(type){
        case "Attention":
            return Attention.src;
        case "Success":
            return Success.src;
        default:
            return Error.src;
    }
};
var getMessage = function(type) {
    switch(type){
        case "Attention":
            return "The page you tried to access does not exist. If you think this is a mistake, please contact Demyst support.";
        case "Success":
            return "Your form has been sent successfully. We'll be in touch.";
        default:
            return "There was an unexpected internal error with our server. Please contact Demyst support.";
    }
};
var getActionText = function(type) {
    switch(type){
        case "Success":
            return "Return Home";
        default:
            return "Contact Support";
    }
};
var getActionLink = function(type) {
    switch(type){
        case "Success":
            return linksConstants/* linksConstants.HOME */.s.HOME;
        default:
            return linksConstants/* linksConstants.CONTACT */.s.CONTACT;
    }
};
var InfoBox = function(param) {
    var actionLink = param.actionLink, actionText = param.actionText, _actionVisible = param.actionVisible, actionVisible = _actionVisible === void 0 ? true : _actionVisible, closeModal = param.closeModal, _fromContact = param.fromContact, fromContact = _fromContact === void 0 ? false : _fromContact, text = param.text, title = param.title, _type = param.type, type = _type === void 0 ? "Success" : _type;
    var ref = (0,react.useState)(false), componentMounted = ref[0], setComponentMounted = ref[1];
    (0,react.useEffect)(function() {
        setTimeout(function() {
            return setComponentMounted(true);
        }, 200);
    }, []);
    var closeWithFade = function() {
        setComponentMounted(false);
        setTimeout(function() {
            closeModal();
        }, 500);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "info_box-main ".concat(componentMounted ? "" : "initiated"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "info_box-icon_box ".concat(type.toLowerCase()),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: "info_box-icon",
                    src: getIcon(type),
                    alt: type
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "info_box-text",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "info_box-header",
                        children: title || "".concat(type, "!")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "info_box-message",
                        children: text || getMessage(type)
                    }),
                    actionVisible && !fromContact && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        onClick: closeModal,
                        className: "info_box-action",
                        href: actionLink || getActionLink(type),
                        children: actionText || getActionText(type)
                    }),
                    actionVisible && fromContact && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        onClick: closeModal,
                        className: "info_box-action",
                        href: actionLink || getActionLink(type),
                        children: actionText || getActionText(type)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "info_box-close",
                onClick: function() {
                    return closeWithFade();
                },
                title: "Close",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiX */.q5L, {})
            })
        ]
    });
};
InfoBox.propTypes = {
    actionLink: (prop_types_default()).string,
    actionText: (prop_types_default()).string,
    actionVisible: (prop_types_default()).bool,
    closeModal: (prop_types_default()).func,
    fromContact: (prop_types_default()).bool,
    text: (prop_types_default()).string,
    title: (prop_types_default()).string,
    type: (prop_types_default()).string
};


/***/ }),

/***/ 72573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ useViewport; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/platform/utils/useMediaQuery.js

/**
 * This hook is a kind of React wrapper over `window.matchMedia` functionality. It receives media
 * query as a parameter and determines if the document matches that query. It also monitors changes
 * in document so it will change the returned value if needed.
 * @param query
 * @returns {boolean}
 */ function useMediaQuery(query) {
    var ref = (0,react.useState)(false), matches = ref[0], setMatches = ref[1];
    (0,react.useEffect)(function() {
        var media = window.matchMedia(query);
        if (media.matches !== matches) {
            setMatches(media.matches);
        }
        var listener = function() {
            setMatches(media.matches);
        };
        // older browsers don't have support for`addEventListener` in matchMedia and have to use
        // older "addListener" function
        if (media && media.addEventListener) {
            media.addEventListener("change", listener);
        } else {
            media.addListener(listener);
        }
        return function() {
            if (media && media.removeEventListener) {
                media.removeEventListener("change", listener);
            } else {
                media.removeListener(listener);
            }
        };
    }, [
        matches,
        query
    ]);
    return matches;
}

;// CONCATENATED MODULE: ./src/platform/utils/useViewport.js

var useViewport = function() {
    var desktop_small_min = useMediaQuery("(min-width: 64.001rem)");
    var desktop_min = useMediaQuery("(min-width: 70.001rem)");
    var desktop = useMediaQuery("(max-width: 90rem)");
    var desktop_small = useMediaQuery("(max-width: 70rem)");
    var tablet_landscape = useMediaQuery("(max-width: 64rem)");
    var tablet = useMediaQuery("(max-width: 48rem)");
    var mobile = useMediaQuery("(max-width: 30rem)");
    return {
        desktop_small_min: desktop_small_min,
        desktop_min: desktop_min,
        desktop: desktop,
        desktop_small: desktop_small,
        tablet_landscape: tablet_landscape,
        tablet: tablet,
        mobile: mobile
    };
};


/***/ }),

/***/ 51979:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"HeroContainer":"Hero_HeroContainer__Ub8up","section-layout":"Hero_section-layout__NukfT","HeroColWrapper":"Hero_HeroColWrapper__K8lwy","HeroCol":"Hero_HeroCol__H1sR4","Hero":"Hero_Hero__IzYn4","violet_1000":"Hero_violet_1000__nDw2_","violet_900":"Hero_violet_900__8kNMq","violet_800":"Hero_violet_800__9Ov_m","primary_900":"Hero_primary_900__i2CNY","blue_700":"Hero_blue_700__CUShy","primary_700":"Hero_primary_700__nIDWO","RemoveTopPadding":"Hero_RemoveTopPadding__CN4BG","RemoveBottomPadding":"Hero_RemoveBottomPadding__qbhGD","DoubledPadding":"Hero_DoubledPadding__vFU_V","TypeTwoCol":"Hero_TypeTwoCol__3V9GD","HeroTitle":"Hero_HeroTitle__exoSJ","HeroSubtitle":"Hero_HeroSubtitle__SrMnN","HeroImage":"Hero_HeroImage__ArVxK","TypeTwoColForm":"Hero_TypeTwoColForm__RY5aO","TypeTwoColText":"Hero_TypeTwoColText__oP4n5","NoMarginBottom":"Hero_NoMarginBottom__ooVrG","HeroParagraph":"Hero_HeroParagraph__z_BcO","HeroSubheading":"Hero_HeroSubheading__1VTdO","HeroImageWrapper":"Hero_HeroImageWrapper__AFh54","HeroBadges":"Hero_HeroBadges__bQ0PL","HeroVideo":"Hero_HeroVideo__VmANL","HeroVideoPlaceholderImage":"Hero_HeroVideoPlaceholderImage__bJpyU","HeroVideoPlaceholder":"Hero_HeroVideoPlaceholder__GPzR6","HeroVideoPlayer":"Hero_HeroVideoPlayer__nOxnQ","HeroStars":"Hero_HeroStars__QVgWJ","HeroStars1":"Hero_HeroStars1__qW2cZ","animateStar":"Hero_animateStar__fas14","HeroStars2":"Hero_HeroStars2__TpJRT"};

/***/ }),

/***/ 48900:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Customers":"Customers_Customers__4fdox","CustomersMargin":"Customers_CustomersMargin__LJDSh","CustomersHeader":"Customers_CustomersHeader__6lKvo","CustomersLogosSlider":"Customers_CustomersLogosSlider__XT3_j","CustomersLogosTrack":"Customers_CustomersLogosTrack__u_0zQ","trackslide":"Customers_trackslide__HouPN","CustomersLogosSlide":"Customers_CustomersLogosSlide__UUzik","BrightLogo":"Customers_BrightLogo__dFg_w"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3430,8391,1664,2777,314,5675,9223,9774,2888,179], function() { return __webpack_exec__(43647); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);